import styles from "./AddToHomeScreenPage.module.scss";
import { PageTitleBlock } from "../../../../components/PageTitleBlock/PageTitleBlock";
import { CardWrapper } from "../../../../components/CardWrapper/CardWrapper";
import { Highlightable } from "../../../../components/Highlight/Highlightable";
import { ActionPromptType } from "../../../../hooks/prompts";
import { addToHomeScreen, checkHomeScreenStatus } from '@telegram-apps/sdk';
import { useEffect, useState } from "react";
import { TicketsPanel } from "../../../../components/TicketsPanel/TicketsPanel";
import { useDispatch, useSelector } from "../../../../hooks";
import { Button } from "../../../../components/Buttons/Button/Button";
import { setHomescreenShortcutTask } from "../../../../redux/tasks/set-homescreen-shortcut.handler";
import { setUserExp, setUserTickets } from "../../../../redux/user";
import { omit } from "lodash";
import { PlatformType, getPlatform } from "../../../../utils/browser";

export const AddToHomeScreenPage = () => {
    const [checkInterval, setCheckInterval] = useState<NodeJS.Timeout | null>(null);
    const taskData = useSelector(store => store.tasks.homescreenShortcutTask);
    const dispatch = useDispatch();

    const onAddHandler = async () => {
        addToHomeScreen.ifAvailable();
        startChecking();
    }

    const checkStatus = async (): Promise<string | null> => {
        if (checkHomeScreenStatus.isAvailable()) {
            try {
                return await checkHomeScreenStatus();
            } catch (error) {
                return null;
            }
        }
        return null;
    }

    const send = async () => {
        const resultAction = await dispatch(setHomescreenShortcutTask());
        if (setHomescreenShortcutTask.fulfilled.match(resultAction)) {
            const { reward } = resultAction.payload;
            if (reward?.balances !== undefined)
                dispatch(setUserTickets(omit(reward.balances, 'balance')));

            if (reward?.exp !== undefined)
                dispatch(setUserExp(reward.exp));
        }
    }

    const startChecking = () => {
        if (checkInterval)
            clearInterval(checkInterval);
        
        const interval = setInterval(async () => {
            const status = await checkStatus();            
            if (status) {
                if (status === 'added' || status === 'installed' || getPlatform() === PlatformType.iOS) {
                    clearInterval(interval);
                    setCheckInterval(null);
                    send();
                }
            }
        }, 2000);
        
        setCheckInterval(interval);
    }

    useEffect(() => {
        return () => {
            if (checkInterval)
                clearInterval(checkInterval);
        };
    }, [checkInterval]);

    const getPerformed = () => <span className={ styles.performed  }>Задание выполнено</span>

    const getButton = () => (
        <CardWrapper>
            <Highlightable promptType={ ActionPromptType.PLACE_ICON_ON_DESKTOP_FIRST_TIME } highlightClass={ styles.highlight } >
                <Button handler={ onAddHandler } caption="Добавить иконку" />
            </Highlightable>
        </CardWrapper>
    )

    return (
        <div className={styles.tasksWrapper}>
            <PageTitleBlock
                pageTitle="Добавить иконку"
                pageDescription='Добавьте иконку игры на домашний экран смартфона и получите награду'
            />
            
            <TicketsPanel
                precission={0}
                { ...taskData?.reward }
            />

            { taskData?.isPerformed
                ? getPerformed() 
                : getButton()
            }
        </div>
    );
}